import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["total", "row", "unitCost", "quantity", "lineTotal"]
  static values = { currency: String }

  recalculate() {
    this.rowTargets.forEach((row, index) => {
      const unitCost = parseFloat(this.unitCostTargets[index].value) || 0
      const quantity = parseFloat(this.quantityTargets[index].value) || 0
      const lineTotal = unitCost * quantity
      this.lineTotalTargets[index].textContent = this.formatCurrency(lineTotal)
    })

    this.updateTotal()
  }

  toggleRow(event) {
    const row = event.target.closest("tr")
    const checked = event.target.checked
    const inputs = row.querySelectorAll("input[type=number]")

    inputs.forEach(input => { input.disabled = !checked })
    row.classList.toggle("line-through", !checked)
    row.classList.toggle("text-neutral-400", !checked)

    this.recalculate()
  }

  updateTotal() {
    let total = 0

    this.rowTargets.forEach((row, index) => {
      const checkbox = row.querySelector("input[type=checkbox]")
      if (!checkbox.checked) return

      const unitCost = parseFloat(this.unitCostTargets[index].value) || 0
      const quantity = parseFloat(this.quantityTargets[index].value) || 0
      total += unitCost * quantity
    })

    this.totalTarget.textContent = this.formatCurrency(total)
  }

  formatCurrency(amount) {
    return this.currencyValue + amount.toFixed(2)
  }
}
